function createSvgEventHandler(eventName, eventDetailsExtractor) {
  return function svgEventHandler(e) {
    const target = e.target
    const details = eventDetailsExtractor(target)
    dispatchCustomEvent(eventName, target, details)
  }
}

function dispatchCustomEvent(eventName, target, details) {
  const event = new CustomEvent(eventName, {
    bubbles: true,
    detail: details
  })
  target.dispatchEvent(event)
}

const inputDetailsExtractor = (target) => ({
  dimensionId: target.getAttribute('dimensionid'),
  element: target
})

const interactionDetailsExtractor = (target) => ({
  active: String(target.getAttribute('interactionactive')).toUpperCase() === 'Y',
  type: target.getAttribute('interactiontype'),
  componentId: target.getAttribute('componentid'),
  memberId: target.getAttribute('memberid')
})

const designSelectorDetailsExtractor = (target) => ({
  componentId: target.getAttribute('componentid')
})

const selectorDetailsExtractor = (target) => ({
  componentId: target.getAttribute('componentid'),
  memberId: target.getAttribute('memberid')
})

export default {
  install() {
    window.svg_Dimension_Input_Input = createSvgEventHandler('input-input', inputDetailsExtractor)
    window.svg_Dimension_Input_Click = createSvgEventHandler('input-click', inputDetailsExtractor)
    window.svg_Dimension_Input_KeyPress = createSvgEventHandler('input-key-press', inputDetailsExtractor)
    window.svg_Dimension_Input_Focus = createSvgEventHandler('input-focus', inputDetailsExtractor)
    window.svg_Dimension_Input_Blur = createSvgEventHandler('input-blur', inputDetailsExtractor)
    window.svg_interaction_onclick = createSvgEventHandler('diagram-clicked', interactionDetailsExtractor)
    window.svg_Design_Selector_Click = createSvgEventHandler('design-selector-clicked', designSelectorDetailsExtractor)
    window.svg_Selector_Click = createSvgEventHandler('selector-clicked', selectorDetailsExtractor)
  }
}
